export default __webpack_public_path__ + "1b53bcea3509e09e867a272190094688.svg";